module.exports = __webpack_public_path__ + "img/kostal.375d29d7.png";